module.exports = __webpack_public_path__ + "static/img/gj007.faff237.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/projectApplication/gj007.png
// module id = 1sVa
// module chunks = 1